var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoTemplateGrader = function SvgInfoTemplateGrader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52 2.735a.804.804 0 1 0 1.137 1.138.804.804 0 0 0-1.138-1.138Z",
    fill: "#EFEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667.167H11.51V11.01H.667V.167Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61 9.11a4.961 4.961 0 0 1-3.522 1.455A4.965 4.965 0 0 1 2.567 9.11a4.986 4.986 0 0 1 0-7.042 4.986 4.986 0 0 1 7.043 0 4.986 4.986 0 0 1 0 7.042Zm.314-7.358a5.43 5.43 0 0 0-7.671 0 5.43 5.43 0 0 0 0 7.672 5.409 5.409 0 0 0 3.835 1.586c1.39 0 2.778-.53 3.836-1.586a5.43 5.43 0 0 0 0-7.672Z",
    fill: "#EFEEEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 11.01H11.51V.167H.667V11.01Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.644 8.683h.889V5.086h-.889v3.597Z",
    fill: "#EFEEEE"
  }))));
};
export { SvgInfoTemplateGrader as ReactComponent };
export default "data:image/svg+xml;base64,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";